<template>
  <Popover
    trigger="click"
    placement="bottomLeft"
    overlayClassName="coope-panel-popover-container"
    :arrow="false"
    :align="{ offset: [-257, 0] }"
    v-model="visible"
    @visibleChange="handleVisibleChange"
  >
    <span :class="labelClasses"
      ><span class="control-label">{{$t('home.Company')}}</span>
      <span class="arrow-icon" :class="{actived: visible}"><SvgIcon icon-class="arrow-left" /></span
    ></span>
    <FlexScrollBox slot="content">
      <div slot="header" style="padding: 32px 32px 24px">
        <IndentInput v-model="searchText" @change="handleSearchCorps" style="height: 42px; font-size: 16px" allowClear :placeholder="$t('home.SearchCompanies')" />
      </div>
      <CheckboxGroup slot="main" v-model="selectedCorpIds" style="width: 100%">
        <div v-for="group in corpsGroupByLetter" :key="group.letter">
          <div style="height: 40px;background: #f7f8fa;padding: 9px 32px;">{{group.letter}}</div>
          <div v-for="corp in group.corps" :key="corp.corpId" class="corp-item">
            <Checkbox :value="corp.corpId">{{corp.corpName}}</Checkbox>
          </div>
        </div>
      </CheckboxGroup>
      <div slot="footer" class="control-extra-footer">
        <BasicBtnGroup @primeClick="handleOk" @defClick="handleClearEntpr">
          <span slot="defContent" style="color: #000">{{$t('common.Clear')}}</span>
        </BasicBtnGroup>
      </div>
    </FlexScrollBox>
  </Popover>
</template>
<script>
import { Popover, Checkbox } from 'ant-design-vue'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import IndentInput from '@/components/behavior/indent-input/index.vue'
import FlexScrollBox from '@/components/behavior/flex-scroll-box/index.vue'
import { debounce } from '@/utils/ops'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CoopePanelEntprControl',
  props: {
    getPopupContainer: {
      type: Function,
      required: false,
    },
  },
  components: {
    Popover,
    BasicBtnGroup,
    IndentInput,
    FlexScrollBox,
    Checkbox,
    CheckboxGroup: Checkbox.Group
  },
  data() {
    return {
      visible: false,
      selectedCorpIds: [],
      corps: [],
      searchText: ''
    }
  },
  computed: {
    ...mapGetters('coc', ['getCorpsByName']),
    ...mapState('coc', ['cocsQuery']),
    corpsGroupByLetter() {
      const corps = this.corps
      const corpsByLetter = {}
      const others = []
      const alphabet = /[0-9a-zA-Z]/
      for (const corp of corps) {
        const letter = corp.corpNameSpell.charAt(0)
        if (alphabet.test(letter)) {
          let groupCorps = corpsByLetter[letter]
          if (!groupCorps) {
            groupCorps = []
            corpsByLetter[letter] = groupCorps
          }
          groupCorps.push(corp)
        } else {
          others.push(corp)
        }
      }

      const sortedCorps = Object.entries(corpsByLetter).map(([letter, corps]) => {
        corps.sort((a, b) => a.corpNameSpell.localeCompare(b.corpNameSpell))
        return { letter, corps }
      }).sort((a, b) => a.letter.localeCompare(b.letter))

      if (others.length > 0) {
        others.sort((a, b) => a.corpNameSpell.localeCompare(b.corpNameSpell))

        sortedCorps.push({
          letter: 'Other',
          corps: others
        })
      }

      return sortedCorps
    },
    labelClasses() {
      const { corps = [] } = this.cocsQuery
      return corps.length === 0 ? 'coope-panel-control' : 'coope-panel-control actived'
    }
  },
  created() {
    this.syncSearchCorps = debounce(text => {
      this.corps = this.getCorpsByName(text) || []
    }, 300)

    this.syncSearchCorps('')
  },
  methods: {
    ...mapActions('coc', ['reloadCocs']),
    handleOk() {
      this.reloadCocs({ corps: this.selectedCorpIds })
      this.visible = false
    },
    handleVisibleChange(visible) {
      if (visible) {
        this.syncSearchCorps('')
        const { corps = [] } = this.cocsQuery
        this.selectedCorpIds = corps.slice()
      }
    },
    handleSearchCorps() {
      this.syncSearchCorps(this.searchText)
    },
    handleClearEntpr() {
      this.selectedCorpIds = []
    }
  }
}
</script>
<style scoped lang="less">
@import url(~@/styles/font.less);
@import url(./control.less);
.corp-item {
  height: 40px;
  padding: 9px 24px;margin: 2px 8px;
  border-radius: 4px;
  ::v-deep .ant-checkbox-wrapper {
    color: #000;
    & > .ant-checkbox {
      .regular-font(16);
    }
  }

  &:hover {
    background: #f3f6fb;
  }
}
</style>
